import { useContext } from 'react';

import { CampaignContext } from '@/providers/AuthProvider/campaignInfoProvider';
import { LaboratoryContext } from '@/providers/AuthProvider/labInfoProvider';
import { PharmacyContext } from '@/providers/AuthProvider/pharmacyInfoProvider';

// Priority: pharmacy > campaign > laboratory. Undefined lets components keep their default color.
const useBrandPrimaryColor = (): string | undefined => {
    const { pharmacy } = useContext(PharmacyContext);
    const { primaryColor: campaignPrimaryColor } = useContext(CampaignContext);
    const { laboratory } = useContext(LaboratoryContext);

    return pharmacy?.color1 || campaignPrimaryColor || laboratory.primaryColor || undefined;
};

export default useBrandPrimaryColor;
